import { render, staticRenderFns } from "./OccupationOrderComponent.vue?vue&type=template&id=8a9076b6"
import script from "./OccupationOrderComponent.vue?vue&type=script&lang=js"
export * from "./OccupationOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports